import { getApp, getApps, initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

const app = getApps().length > 0 ? getApp() : initializeApp(firebaseConfig);

const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);

/**
 * Zweite Firebase-App nur für das Anlegen neuer Staff-Accounts.
 * So bleibt der aktuell eingeloggte Admin auf der Haupt-Auth-Instanz aktiv.
 */
const secondaryAppName = "acetime-admin-worker";

const secondaryApp =
  getApps().find((entry) => entry.name === secondaryAppName) ||
  initializeApp(firebaseConfig, secondaryAppName);

const secondaryAuth = getAuth(secondaryApp);

export { app, auth, db, storage, secondaryApp, secondaryAuth };